module.exports = __webpack_public_path__ + "img/poker-h11.faeca1aa.svg";